import { gql } from '@apollo/client';

export const LOAD_CUSTOMER_DOCUMENT = gql`
    mutation LoadCustomerDocument($documentType: CustomerDocumentType!, $documentNumber: String!) {
        loadCustomerDocument(documentType: $documentType, documentNumber: $documentNumber) {
            fileName
            binData
        }
    }
`;
